<div id="print-section">
  <div class="company-details">
    <h2 class="company-name">{{ company_name }}</h2>
    <p class="company-address">{{ company_address }}</p>
  </div>

  <div class="voucher-info">
    <h2 class="voucher-title">{{ voucherName }}</h2>
    <p class="voucher-meta">
      No:{{voucherNumber}}&nbsp;&nbsp;Date:{{date|date:'dd-MMM-yyyy'}}
    </p>
  </div>

  <table class="ledger-table">
    <thead>
      <tr>
        <th class="left-align">Particulars</th>
        <th>Debit</th>
        <th>Credit</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let debit of data.debits">
        <td class="left-align">{{ debit.ledger_name }}</td>
        <td>{{ debit.amount | number: '1.2-2'}}</td>
        <td></td>
      </tr>

      <tr *ngFor="let credit of data.credits">
        <td class="left-align">{{ credit.ledger_name }}</td>
        <td></td>
        <td>{{ credit.amount | number: '1.2-2' }}</td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td class="left-align"><strong>Total</strong></td>
        <td><strong>₹ {{ getTotalDebit() | number: '1.2-2' }}</strong></td>
        <td><strong>₹ {{ getTotalCredit() | number: '1.2-2' }}</strong></td>
        <td></td>
      </tr>
    </tfoot>
  </table>

  <div class="narration-box">
    <p class="narration-label">On Account of:</p>
    <p class="narration-text">{{ narration }}</p>
  </div>
</div>

<div class="modal-actions">
  <button mat-button class="action-btn print-btn" (click)="printModal()">🖨 Print</button>
    <button mat-button class="action-btn"
          style="background-color: #1976d2; color: #fff"
          (click)="goToPostedVoucherIndex()">
    📂 Go to Posted Voucher Index
  </button>
  <!-- <button mat-button class="action-btn export-btn">📄 Export PDF</button> -->
  <button mat-button class="action-btn danger-btn" style="background-color: red" mat-dialog-close>Cancel</button>
</div>

